// The Market panel's backing-share strings. They live here rather than in
// copy.ts, which is past the file budget (EPIC-022 Locked architecture).
export const backingCopy = {
  field: "Backing share (%)",
  hint: "Each producer gets this share of the fan picks on them, win or lose. House picks and a producer's own picks earn none. Up to 10%, and fee + producer cut + backing share stay at or under 30%.",
  takeLocked: "Picks are in, so the fee, producer cut, and backing share are fixed.",
};
